import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./button.html";
export const BUTTON = 'button';
export const LINK = 'link';
export let Variant = /*#__PURE__*/function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  Variant["Tertiary"] = "tertiary";
  Variant["Text"] = "text";
  return Variant;
}({});
export let Theme = /*#__PURE__*/function (Theme) {
  Theme["Default"] = "default";
  Theme["Success"] = "success";
  Theme["Warning"] = "warning";
  Theme["Error"] = "error";
  return Theme;
}({});
export let Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Large"] = "large";
  Size["Small"] = "small";
  Size["XSmall"] = "xsmall";
  return Size;
}({});
export let Width = /*#__PURE__*/function (Width) {
  Width["Default"] = "default";
  Width["Fill"] = "fill";
  return Width;
}({});
export let IconPosition = /*#__PURE__*/function (IconPosition) {
  IconPosition["Default"] = "start";
  IconPosition["End"] = "end";
  return IconPosition;
}({});
export let IconSize = /*#__PURE__*/function (IconSize) {
  IconSize["Default"] = "default";
  IconSize["Large"] = "large";
  IconSize["Small"] = "small";
  IconSize["XSmall"] = "xsmall";
  return IconSize;
}({});
export let IconPlacement = /*#__PURE__*/function (IconPlacement) {
  IconPlacement["Start"] = "start";
  IconPlacement["End"] = "end";
  return IconPlacement;
}({});
class WdsButton extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * we're redefining id here and exposing it
    this.id = null;
    this.variant = Variant.Primary;
    this.size = Size.Default;
    this.disabled = false;
    this.label = null;
    this.text = null;
    // TEMPORARY PROPERTY TO MATCH ax-button to prevent breaking WP changes! DO NOT USE!
    this.ariaLabel = null;
    this.ariaLive = null;
    this.ariaExpanded = null;
    this.ariaControls = null;
    this.form = null;
    this.theme = Theme.Default;
    this.width = Width.Default;
    this.href = null;
    this.type = null;
    this.icon = null;
    this.iconPosition = IconPosition.Default;
    this.iconPlacement = IconPlacement.Start;
    this.iconSize = IconSize.Default;
    this.iconSpriteUrl = null;
    this.target = null;
  }
  // The analytics wrapper sits between this host and ax-button, so delegatesFocus cannot reach
  // the actual control. Expose an explicit focus API for modal focus restoration and other
  // programmatic focus flows; ax-button forwards this call to its native button or link.
  focus() {
    this.template?.querySelector('ax-button')?.focus();
  }

  // WARNING: This is temporary until we change WordPress implementation to use label property. This was made to
  // prevent a breaking change deploy where both text and label are valid properties that do the same thing.
  get displayText() {
    return this.label || this.text;
  }
  set name(value) {
    this._name = value;
  }
  get name() {
    return this._name || this.displayText || '';
  }
  get analyticsSourceProps() {
    return {
      disabled: this.disabled,
      callToAction: {
        label: this.displayText,
        name: this.name,
        url: this.href
      },
      size: this.size,
      variant: this.variant
    };
  }
  get elementType() {
    return this.href ? LINK : BUTTON;
  }
  handleAnalytics(event) {
    event.detail[this.elementType] = this.analyticsSourceProps;
  }
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
  get renderIcon() {
    return Boolean(this.icon);
  }
  get iconSlot() {
    return this.iconPosition;
  }
  /*LWC compiler v7.1.3*/
}
// this makes any focus on the component to cascade down to Button or A
// https://developer.salesforce.com/docs/platform/lwc/guide/create-components-focus.html
WdsButton.delegatesFocus = true;
_registerDecorators(WdsButton, {
  publicProps: {
    id: {
      config: 0
    },
    variant: {
      config: 0
    },
    size: {
      config: 0
    },
    disabled: {
      config: 0
    },
    label: {
      config: 0
    },
    text: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    ariaExpanded: {
      config: 0
    },
    ariaControls: {
      config: 0
    },
    form: {
      config: 0
    },
    theme: {
      config: 0
    },
    width: {
      config: 0
    },
    href: {
      config: 0
    },
    type: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconPosition: {
      config: 0
    },
    iconPlacement: {
      config: 0
    },
    iconSize: {
      config: 0
    },
    iconSpriteUrl: {
      config: 0
    },
    target: {
      config: 0
    },
    name: {
      config: 3
    }
  },
  publicMethods: ["focus"]
});
const __lwc_component_class_internal = _registerComponent(WdsButton, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;